<template>
  <div class="zcontainer">
    <!--UPLOAD-->
    <form
      enctype="multipart/form-data"
      novalidate
      v-if="isInitial || isSaving || isSuccess"
    >
      <div
        id="dropzone"
        class="dropbox"
        v-cloak
        @drop.prevent="addFile($event)"
        @dragover.prevent
      >
        <input
          type="file"
          :multiple="multiple"
          :name="uploadFieldName"
          :disabled="isSaving"
          @change="filesChange($event, $event.target.name, $event.target.files)"
          :accept="accept"
          class="input-file"
        />
        <p v-if="isInitial || isSuccess">
          Arrastra archivos aquí<br />
          o haz click
        </p>
        <p v-if="isSaving">Subiendo {{ fileCount }} archivos...</p>
      </div>
    </form>

    <div
      class="notification is-info zis-light"
      v-if="fileCount > 0"
      style="margin-top: 0.5rem"
    >
      <div v-if="fileCount > 0">
        <b class="subtitle">Subiendo {{ fileCount }} archivos...</b>
      </div>
      <div v-if="fileCount > 0">
        <div v-for="(file, i) in fileList" v-bind:key="i">
          {{ file.name }}
        </div>
      </div>
    </div>

    <!--SUCCESS-->
    <div v-if="false && isSuccess">
      <h2 class="has-text-primary">
        Uploaded {{ uploadedFiles.length }} file(s) successfully.
      </h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Upload again</a>
      </p>
    </div>
    <!--FAILED-->
    <div v-if="isFailed">
      <h2>Uploaded failed.</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">Volver a probar</a>
      </p>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../services/event-bus.js";
import { upload } from "../services/file-upload.service";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "app",
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      fileCount: 0,
      fileList: [],
    };
  },
  props: {
    prefix: String,
    galleryId: String,
    accept: String,
    multiple: Boolean
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  methods: {
    addFile(e) {
      console.log("addFile", e);
      let fileList = e.dataTransfer.files;
      if (!fileList) return;

      const formData = new FormData();

      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(this.galleryId, fileList[x], fileList[x].name);
      });

      this.fileCount = fileList.length;

      // save it
      this.save(formData, fileList);
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData, fileList) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;

      upload(this.prefix, this.galleryId, formData)
        .then((x) => {
          this.uploadedFiles = [].concat(x);
          this.currentStatus = STATUS_SUCCESS;
          //alert('uploaded')

          this.$emit("uploaded", {
            galleryId: this.galleryId,
            fileList: fileList,
          });
        })
        .catch((err) => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    filesChange(event, fieldName, fileList) {
      //console.log('(fieldName, fileList)', fieldName, fileList)
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(this.galleryId, fileList[x], fileList[x].name);
      });

      this.fileCount = event.target.files.length;
      //this.fileList = event.target.files
      for (let i in event.target.files) {
        this.fileList.push(event.target.files[i]);
      }
      // save it
      this.save(formData, fileList);
    },
  },
  mounted() {
    this.reset();
    EventBus.$on('file-uploaded', (fileInfo) => {
      // console.log('file-uploaded', fileInfo)
      const fileElement = this.fileList.find((f) => f.name === fileInfo.name);
      if (fileElement) {
        this.fileList = this.fileList.filter((f) => f.name !== fileInfo.name);
        this.fileCount--;

        const image = {
          name: fileInfo.name,
          //url: fileInfo.url,
          gs: fileInfo.gs,
          gallery: this.galleryId,
        };
        //this.$store.dispatch("createImage", image);
      }
      //console.log(`Oh, that's nice`, fileInfo)
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dropbox {
  outline: 2px dashed #aaa; /* the dash box */
  outline-offset: -10px;
  background: #f9f9f9;
  background: #eeeeee;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
  font-family: "Varela Round";
  margin-bottom: 2rem;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: #ddd; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1em;
  text-align: center;
  padding: 50px 0;
}
</style>
